import 'css/src/data/transcript/nodes/TrimElementNode';

import type { LexicalNode, SerializedElementNode, Spread } from 'lexical';
import { ElementNode } from 'lexical';

export type SerializedTrimElementNode = Spread<
    {
        type: 'trim-node';
        version: 1;
    },
    SerializedElementNode
>;

/**
 * Please refer to below for the tree structure of nodes
 *                                              [ Root ]
 *    [TrimElement]          [Word 6...Word 12]        [OverlayElement]                        [TrimElement]
 * [...words left of trim]                         [Drag, BaseOverlay, Drag]              [...words right of trim]
 *                                                 [...words inside overlay]
 *
 * words left/right of trim means those word nodes are trimmed out of the transcript and do not appear to the user
 * but user can un-trim to re-reveal those words, that's why we still maintain them inside lexical
 */
export class TrimElementNode extends ElementNode {
    static override getType(): string {
        return 'trim-node';
    }

    static override clone(node: TrimElementNode): TrimElementNode {
        return new TrimElementNode(node.__key);
    }

    override createDOM(): HTMLElement {
        // Create base overlay with icon
        const dom = document.createElement('span');
        dom.className = 'trim-node';
        return dom;
    }

    override updateDOM(): boolean {
        return false;
    }

    static override importJSON(): TrimElementNode {
        const node = $createTrimElementNode();
        return node;
    }

    override exportJSON(): SerializedTrimElementNode {
        return {
            ...super.exportJSON(),
            type: 'trim-node',
            version: 1,
        };
    }
}

export function $isTrimElementNode(node: LexicalNode | null | undefined): node is TrimElementNode {
    return node instanceof TrimElementNode;
}

export function $createTrimElementNode(): TrimElementNode {
    return new TrimElementNode();
}
